module.exports = __webpack_public_path__ + "static/media/avatar-2.29052aee.png";